// src/oura/ui/useMediaQuery.ts
//
// A media query rather than a resize handler: the browser already knows the
// answer and only tells us when it changes, where a resize listener asks on
// every frame of a drag. Falls back to "no match" where matchMedia is absent,
// which is the desktop layout every screen was built for.

import { useEffect, useState } from "react";

function matches(query: string): boolean {
    try {
        return window.matchMedia(query).matches;
    } catch {
        return false;
    }
}

export function useMediaQuery(query: string): boolean {
    const [match, setMatch] = useState(() => matches(query));
    useEffect(() => {
        let mql: MediaQueryList;
        try {
            mql = window.matchMedia(query);
        } catch {
            return;
        }
        const onChange = (e: MediaQueryListEvent) => setMatch(e.matches);
        setMatch(mql.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);
    return match;
}

/** Below 1024px: too narrow for an open sidebar beside the content. */
export const NARROW_VIEWPORT = "(max-width: 1023px)";

export const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
